import React, { useEffect }from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';


const Home = () => {
    window.location = process.env.REACT_APP_MICROSITE_URL;
    return (
        <>
            {/* <div className="preloader">
                <div className="loader rubix-cube">
                    <div className="layer layer-1"></div>
                    <div className="layer layer-2"></div>
                    <div className="layer layer-3 color-1"></div>
                    <div className="layer layer-4"></div>
                    <div className="layer layer-5"></div>
                    <div className="layer layer-6"></div>
                    <div className="layer layer-7"></div>
                    <div className="layer layer-8"></div>
                </div>
            </div> */}
            <section id="slider-part" className="slider-active">
                <div className="single-slider slider-2 bg_cover" style={{ "backgroundImage": "url(images/slider/slide-2.jpg)" }} data-overlay="4">
                    <div className="container">
                        <div className="row">
                            <div className="offset-xl-2 offset-lg-2col-xl-9 col-lg-10">
                                <div className="slider-cont">
                                    <h1 data-animation="bounceInLeft" data-delay="1s">CDRI Fellowship Cohort 2023-24
                                        <p className='text-center m-0'>Awardees announced at ICDRI 2023</p>
                                    </h1>
                                    <Link to="fellows-2023-2024" data-animation="fadeInUp" data-delay="1.3s" className="main-btn">Click here to view</Link>
                                    {/* <div className='row'>
                                        <div className='col-md-4'>
                                        </div>
                                        <div className='col-md-8'>
                                            
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="single-slider slider-2 bg_cover" style={{ "backgroundImage": "url(images/slider/slide-1.jpg)" }} data-overlay="4">
                    <div className="container">
                        <div className="row">
                            <div className="offset-xl-2 offset-lg-2col-xl-9 col-lg-10">
                                <div className="slider-cont">
                                    <h1 className='mt-100' data-animation="bounceInLeft" data-delay="1s">CDRI Fellowship Cohort 2022-23</h1>
                                    <Link to="fellows-2022-2023" data-animation="fadeInUp" data-delay="1.3s" className="main-btn">Click here to view</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="single-slider slider-2 bg_cover" style={{ "backgroundImage": "url(images/slider/slide-3.jpg)" }} data-overlay="4">
                    <div className="container">
                        <div className="row">
                            <div className="offset-xl-2 offset-lg-2col-xl-9 col-lg-10">
                                <div className="slider-cont">
                                    <h1 className='mt-100' data-animation="bounceInLeft" data-delay="1s">CDRI Fellowship Cohort 2021-22</h1>
                                    <Link to="fellows-2021-2022" data-animation="fadeInUp" data-delay="1.3s" className="main-btn">Click here to view</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* <div className="single-slider slider-2 bg_cover" style={{ "backgroundImage": "url(images/slider/slide-3.jpg)" }} data-overlay="4">
                    <div className="container">
                        <div className="row">
                            <div className="offset-xl-2 offset-lg-2 col-xl-9 col-lg-10">
                                <div className="slider-cont">
                                    <h1 data-animation="bounceInLeft" data-delay="1s">CDRI Fellowship Cohort 2021-22</h1>
                                    <Link to="fellows-2021-2022" data-animation="fadeInUp" data-delay="1.3s"  className="main-btn">CDRI Fellows</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </section>



            <section id="about-page" className="pt-10 pb-20">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">

                            <div className="section-title mt-50"><h3>CDRI FELLOWSHIP PROGRAMME</h3></div>
                            {/* <div className="section-title mt-50">
                                <h5>CDRI FELLOWSHIP PROGRAMME</h5>

                            </div> */}
                            <div className="about-cont">
                                <p>Making tomorrow’s infrastructure sustainable and resilient requires investing in high calibre research and innovation today. Increasingly complex infrastructure systems of the 21st century require capabilities that can combine knowledge from multiple disciplines, harness the promise of emerging technologies, and bring together insights from the local level. The CDRI Fellowship Programme is designed to develop a global pool of practitioners who represent such capabilities.</p>
                                <br />

                                <Link to="fellowship-programme" className="main-btn">Read More</Link>


                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="about-image mt-50">

                                <img src="images/fellowship.png" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>



            <div id="counter-part" className="bg_cover pt-65 pb-110" data-overlay="8" >

                <div className="container">

                    <div className="row">


                        <div className="col-lg-4 col-sm-6">
                            <div className="singel-counter text-center mt-40">
                                <span>US$</span>&nbsp;<span className="counter"> 15,000</span>
                                <p>Fellowship Amount</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="singel-counter text-center mt-40">
                                <span><i className="fa fa-calendar"></i></span>&nbsp; <span className="counter">12</span>&nbsp;&nbsp;<span className="small">months</span>&nbsp;
                                <p>Fellowship Duration</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-sm-6">
                            <div className="singel-counter text-center mt-40">
                                <a href="https://www.cdri.world/members" target={'_blank'} className='location'><span><i className="fa fa-map-marker"></i></span>&nbsp;  <span className="counter">31</span></a>
                                &nbsp;&nbsp;<p>Eligible Countries</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>














            <section id="teachers-part" className="pt-65 pb-120 gray-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title mt-50 pb-25">
                                <h3 className='text-center'>THEMATIC AREAS: 2022-23 FELLOWSHIP PROGRAMME COHORT</h3>
                            </div>






                            <div className="row">
                                <div className='col-md-4'>
                                    <div className='flip-card'>
                                        <div className='flip-card-inner'>
                                            <div className='flip-card-front'>
                                                <img src="images/thematic/governmencepolicy.png" className="hex-icon" width="45px" alt="Category" style={{ margintop: 90 }} />
                                                <h5 className="pt-15">Early warning &amp; decision support system for infrastructure</h5>
                                            </div>
                                            <div className='flip-card-back'>
                                                <h5 className='pt-15 back-head'>Early warning &amp; decision support system for infrastructure</h5>
                                                <p className='flipbackpara'>Our current and future infrastructure is at risk from disasters. A key intervention to mitigate the impacts of these disasters involves the use of Early Warning Systems (EWS) and efficient Decision Support Systems (DSS).</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-4'>
                                    <div className='flip-card'>
                                        <div className='flip-card-inner'>
                                            <div className='flip-card-front'>
                                                <img src="images/thematic/riskidentification.png" className="hex-icon" width="45px" alt="Category" style={{ margintop: 90 }} />
                                                <h5 className="pt-15">Resilience standards for infrastructure</h5>
                                            </div>
                                            <div className='flip-card-back'>
                                                <h5 className='pt-15 back-head'>Resilience standards for infrastructure</h5>
                                                <p className='flipbackpara'>Standards are crucial in scaling up disaster and climate resilience in infrastructure investments and ensuring that infrastructure is prepared to withstand present and future disasters.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-4'>
                                    <div className='flip-card'>
                                        <div className='flip-card-inner'>
                                            <div className='flip-card-front'>
                                                <img src="images/thematic/resilience.png" className="hex-icon" width="45px" alt="Category" style={{ margintop: 90 }} />
                                                <h5 className="pt-15">Nature-based solutions for infrastructure resilience</h5>
                                            </div>
                                            <div className='flip-card-back'>
                                                <h5 className='pt-15 back-head'>Nature-based solutions for infrastructure resilience</h5>
                                                <p className='flipbackpara'>Nature-based Solutions (NbS) offer a cost-effective mechanism to boost infrastructure resilience while also improving livelihoods, benefiting economies and ecosystems.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>






                            </div>
                            <div className='row pt-10 pb-20'>

                                <div className='offset-md-2 col-md-4'>
                                    <div className='flip-card'>
                                        <div className='flip-card-inner'>
                                            <div className='flip-card-front'>
                                                <img src="images/thematic/finance.png" className="hex-icon" width="45px" alt="Category" style={{ margintop: 90 }} />
                                                <h5 className="pt-15">Risk finance for infrastructure</h5>
                                            </div>
                                            <div className='flip-card-back'>
                                                <h5 className='pt-15 back-head'>Risk finance for infrastructure</h5>
                                                <p className='flipbackpara'>Risk financing strategies for each nation depend on its capacity, risk appetite, resources, and willingness to manage risk. Nevertheless, appropriate financing can incentivize the resilience of infrastructure systems.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className='col-md-4'>
                                    <div className='flip-card'>
                                        <div className='flip-card-inner'>
                                            <div className='flip-card-front'>
                                                <img src="images/thematic/recovery.png" className="hex-icon" width="45px" alt="Category" style={{ margintop: 90 }} />
                                                <h5 className="pt-15">Health infrastructure resilience</h5>
                                            </div>
                                            <div className='flip-card-back'>
                                                <h5 className='pt-15 back-head'>Health infrastructure resilience</h5>
                                                <p className='flipbackpara'>Since 2020, the COVID-19 pandemic has severely affected countries whilst many
                                                    healthcare systems have reached the point of exhaustion. An avalanche of cases
                                                    combined with aging infrastructure and under-resourced human capacity has
                                                    overburdened the healthcare system in almost all countries.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* <div className='col-md-4'>
                                    <div className='flip-card'>
                                        <div className='flip-card-inner'>
                                            <div className='flip-card-front'>
                                                <img src="images/thematic/recovery.png" className="hex-icon" width="45px" alt="Category" style={{ margintop: 90 }} />
                                                <h5 className="pt-15">Health infrastructure resilience</h5>
                                            </div>
                                            <div className='flip-card-back'>
                                                <h5 className='pt-15 back-head'>Health infrastructure resilience</h5>
                                                <p className='flipbackpara'>Since 2020, the COVID-19 pandemic has severely affected countries whilst many
                                                    healthcare systems have reached the point of exhaustion. An avalanche of cases
                                                    combined with aging infrastructure and under-resourced human capacity has
                                                    overburdened the healthcare system in almost all countries.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}


                            </div>
                            <div className='col-md-12 text-center'>  <Link to="scope" className="main-btn">Read More</Link>

                            </div>






                        </div>
                    </div>
                </div>
            </section>



            <section id="video-feature" className="bg_cover pt-60 pb-110" style={{ "backgroundImage": "url('images/background.jpg')" }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 order-last order-lg-first">
                            <div className="video text-lg-left text-center pt-50">


                                <a className="Video-popup" href="https://www.youtube.com/watch?v=2n1yIR5HBNs"><i className="fa fa-play"></i></a>
                            </div>

                        </div>
                        <div className="col-lg-6  order-first order-lg-last">
                            <div className="feature pt-10">
                                <div className="feature-title">
                                    <h3>INFRASTRUCTURE TYPE</h3>
                                </div>
                                <ul>
                                    <li>
                                        <div className="singel-feature">
                                            <div className="icon">
                                                <img src="images/all-icon/f-1.png" alt="Category" />

                                            </div>
                                            <div className="cont">
                                                <h4>Physical Infrastructure</h4>

                                                <p> Power, Telecommunication, Transport</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="singel-feature">
                                            <div className="icon">
                                                <img src="images/all-icon/f-3.png" alt="Category" />

                                            </div>
                                            <div className="cont">
                                                <h4>Social Infrastructure</h4>
                                                <p>Schools, Health Infrastructure, Community Infrastructure</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="singel-feature">
                                            <div className="icon">
                                                <img src="images/all-icon/f-2.png" alt="Category" />
                                            </div>
                                            <div className="cont">
                                                <h4>Ecological Infrastructure</h4>
                                                <p>Natural Waterways, Wetlands, Mangroves</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feature-bg"></div>
            </section>


            <section id="video-feature" className="bg_cover pt-60 pb-110 gray-bg" >
                <div className="container">
                    <div className="section-title mt-50 pb-75">
                        <h3 className='text-center'>SELECTION PROCESS</h3>
                    </div>
                    <div className="row">
                        <div className='col-md-12'>
                            <div className="stepper-wrapper">
                                <div className="stepper-item completed">
                                    <div className="step-counter">1</div>
                                    <div className="step-name">Receipt of Proposal</div>
                                </div>
                                <div className="stepper-item">
                                    <div className="step-counter">2</div>
                                    <div className="step-name">Desk Screening</div>
                                </div>
                                <div className="stepper-item completed">
                                    <div className="step-counter">3</div>
                                    <div className="step-name">Double Blind Peer Review</div>
                                </div>
                                <div className="stepper-item">
                                    <div className="step-counter">4</div>
                                    <div className="step-name">Review by International Jury</div>
                                </div>
                                <div className="stepper-item completed">
                                    <div className="step-counter">5</div>
                                    <div className="step-name"> Announcement of CDRI Fellows</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </section>


            <section id="teachers-part" className="pt-70 pb-120">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12">
                            {/* <div className="section-title mt-50">
                                <h5>INTERNATIONAL JURY 2022-23 </h5>

                            </div> */}
                            <div className="section-title mt-50 pb-35">
                                <h3 className='text-center'>INTERNATIONAL JURY: 2023-24 FELLOWSHIP PROGRAMME COHORT</h3>
                            </div>


                            <div className="teachers mt-20">
                                <div className="row">
                                    <div className="col-sm-1">
                                        <div className="singel-teachers mt-30 text-center">
                                            {/* <div className="image">
                                                <Link to="/international-jury/charlotte-benson"> <img src="images/jury/08.jpg" alt="Category" />  </Link>
                                            </div>
                                            <div className="cont">
                                                <Link to="/international-jury/charlotte-benson"><h6>Charlotte Benson</h6></Link>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="singel-teachers mt-30 text-center">
                                            <div className="image">
                                                <Link to="/international-jury/jim-hall">  <img src="images/jury/09.jpg" alt="Category" /></Link>
                                            </div>
                                            <div className="cont">
                                                <Link to="/international-jury/jim-hall"><h6>Jim Hall</h6></Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="singel-teachers mt-30 text-center">
                                            <div className="image">
                                                <Link to="/international-jury/marjorie-greene"> <img src="images/jury/07.jpg" alt="Category" /></Link>
                                            </div>
                                            <div className="cont">
                                                <Link to="/international-jury/marjorie-greene"><h6>Marjorie Greene</h6></Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="singel-teachers mt-30 text-center">
                                            <div className="image">
                                                <Link to="/international-jury/ravi-sinha"><img src="images/jury/11.jpg" alt="Category" /></Link>
                                            </div>
                                            <div className="cont">
                                                <Link to="/international-jury/ravi-sinha"><h6>Ravi Sinha</h6></Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-2">
                                        <div className="singel-teachers mt-30 text-center">
                                            <div className="image">
                                                <Link to="/international-jury/satoru-nishikawa"><img src="images/jury/12.jpg" alt="Category" /></Link>
                                            </div>
                                            <div className="cont">
                                                <Link to="/international-jury/satoru-nishikawa"><h6>Satoru Nishikawa</h6></Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-2">
                                        <div className="singel-teachers mt-30 text-center">
                                            <div className="image">
                                                <Link to="/international-jury/deepali-khanna"><img src="images/jury/10.jpg" alt="Category" /></Link>
                                            </div>
                                            <div className="cont">
                                                <Link to="/international-jury/deepali-khanna"><h6>Deepali Khanna</h6></Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-1">
                                        <div className="singel-teachers mt-30 text-center">
                                            {/* <div className="image">
                                                <Link to="/international-jury/charlotte-benson"> <img src="images/jury/08.jpg" alt="Category" />  </Link>
                                            </div>
                                            <div className="cont">
                                                <Link to="/international-jury/charlotte-benson"><h6>Charlotte Benson</h6></Link>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Helmet>
                <script src="js/vendor/modernizr-3.6.0.min.js"></script>
                <script src="js/vendor/jquery-1.12.4.min.js"></script>
                <script src="js/bootstrap.min.js"></script>
                <script src="js/slick.min.js"></script>
                <script src="js/jquery.magnific-popup.min.js"></script>
                <script src="js/jquery.counterup.min.js"></script>
                <script src="js/waypoints.min.js"></script>
                <script src="js/jquery.nice-select.min.js"></script>
                <script src="js/jquery.nice-number.min.js"></script>
                <script src="js/jquery.countdown.min.js"></script>
                <script src="js/validator.min.js"></script>
                <script src="js/ajax-contact.js"></script>
                <script src="js/main.js"></script>
            </Helmet>
        </>
    );
};

export default Home;